// src/RentalPage.js
import React, { useEffect, useMemo, useState } from 'react';
import { api } from '../scripts/api';
import CardComponent from '../components/CardComponent';
import { parseBool } from '../scripts/status';

const matchesSearch = (row, q) =>
  !q || JSON.stringify(row).toLowerCase().includes(q.trim().toLowerCase());

const statusCode = (row) => {
  const raw = row?.unit_status ?? row?.['unit_status.1'];
  const n = Number(raw);
  return Number.isNaN(n) ? null : n;
};

export default function RentalPage() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        setErrMsg('');
        const res = await api.get('/all_inventory'); // ✅
        if (!alive) return;
        setRows(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        if (!alive) return;
        console.error(e);
        setRows([]);
        setErrMsg('Failed to load inventory.');
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  const filtered = useMemo(() => {
    return rows
      .filter(r => {
  if (parseBool(r.is_rental)) return true;
  const cc = String(r.color_code ?? "").trim();
  if (cc === "2") return true;          // fallback: rental color code
  return statusCode(r) === 2;           // optional legacy fallback
})
      .filter(r => matchesSearch(r, q));
  }, [rows, q]);

  return (
    <div className="container">
      <h2>Rental Inventory</h2>

      <input className="input" placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)} />

      {loading && <div className="muted">Loading…</div>}
      {!loading && errMsg && <div className="muted">{errMsg}</div>}
      {!loading && !errMsg && filtered.length === 0 && <div className="muted">No rental units.</div>}

      <div className="col">
        {filtered.map((r) => (
          <CardComponent key={r.id} record={r} table="all_inventory" /> // ✅
        ))}
      </div>
    </div>
  );
}
